import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, inject, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { ApiRequestService, DialogComponent, DialogConfiguration, DialogService, ListViewComponent, TranslationPipe } from '@prekog/common-ui';
import { GetPackagesResponse } from './getpackagesresponse';
import { Package } from './package';
import { RemovePackageRequest } from './removepackagerequest';
import { RemovePackageResponse } from './removepackageresponse';
import { UpdatePackagesOrderRequest } from './updatepackagesorderrequest';

@Component({
    selector: 'pf-existingpackages',
    templateUrl: './packages.component.html',
    styleUrls: ['./packages.component.scss'],
    standalone: true,
    imports: [RouterModule, MatIconModule, CommonModule, FormsModule, DragDropModule, ListViewComponent, TranslationPipe]
})
export class PackagesComponent implements OnInit {
    filteredPackages: Package[] = [];
    getPackagesUrl = '/admin/getpackages';
    packages: Package[] = [];
    placeHolder = 'Csomag neve';
    searchText = '';
    storeBaseUrl = '';
    updatePackagesOrderUrl = '/admin/updatePackagesOrder';
    removePackageUrl = '/admin/remove-package';
    private _dialogService = inject(DialogService);

    constructor(
        private _apiRequestService: ApiRequestService,
        private _router: Router,
        @Inject('STORE_BACKEND_URL') private _storeBaseUrl: string,
    ) {
        this.storeBaseUrl = _storeBaseUrl;
    }

    ngOnInit(): void {
        if (!sessionStorage.getItem('token')) {
            this._router.navigateByUrl('/');
        } else {
            this._apiRequestService
                .sendRequest<{}, GetPackagesResponse>(this.storeBaseUrl, {}, true, this.getPackagesUrl)
                .subscribe((response) => {
                    this.packages = response.packageList!;
                    this.filteredPackages = this.packages;
                });
        }
    }

    drop(event: CdkDragDrop<Package[]>): void {
        moveItemInArray(this.packages, event.previousIndex, event.currentIndex);
    }

    updatePackagesOrder() {
        const updatePackagesOrderRequest: UpdatePackagesOrderRequest = {
            packageOrderList: this.packages.map((pkg, index) => ({
                packageId: pkg.id,
                orderNumber: index
            }))
        };

        this._apiRequestService
            .sendRequest<
                UpdatePackagesOrderRequest,
                HttpResponse<any>
            >(this.storeBaseUrl, updatePackagesOrderRequest, true, this.updatePackagesOrderUrl, true)
            .subscribe();
    }

    openDeletePackageDialog(packageObject: Package) {
        const dialogConfiguration: DialogConfiguration = {
            messageKey: 'packages.deleteConfirmMessage',
            targetData: packageObject.packageName
        }
        this._dialogService.openDialog(
            DialogComponent,
            dialogConfiguration,
            () => {
                this.deletePackage(packageObject);
            }
        );
    }

    deletePackage(packageObject: Package) {
        const removePackageRequest: RemovePackageRequest = {
            packageId: packageObject.id
        };

        this._apiRequestService
            .sendRequest<
                RemovePackageRequest,
                RemovePackageResponse
            >(this.storeBaseUrl, removePackageRequest, true, this.removePackageUrl, true)
            .subscribe(() => {
                this.packages = this.packages.filter((existingPackage) => existingPackage.id !== packageObject.id);
                this.filteredPackages = this.filteredPackages.filter((filteredExistingPackage) => filteredExistingPackage.id !== packageObject.id);
            });
    }
}
